// extracted by mini-css-extract-plugin
export default {"errorPage":"ErrorPage_errorPage__7E-id","body":"ErrorPage_body__YNawP","icon":"ErrorPage_icon__jkq+6"};